//Показване на tooltip за документи по клас
$(function () {
    const tooltips = document.querySelectorAll('.uv-tooltip');
    tooltips.forEach((tooltip) => {
        return new bootstrap.Tooltip(tooltip, {
            title: tooltip.getAttribute('data-original-title'),
        });
    });
});

$(document).on('click', 'path', function (a) {
    window.location = `/${a.target.getAttribute('slug')}/registers`;
});

//Показване на popup
$(function () {
    $('#modal-history').on('show.bs.modal', function (event) {

        let button = $(event.relatedTarget); // Button that triggered the modal
        let fields = button.data('bs-fields') || ["", "Стойност"];
        let rows = button.data('bs-rows');

        let modal = $(this);
        let bottommessage = button.data('bs-bottommessage') || '';
        modal.find('.modal-bottommessage').text(bottommessage);
        let fieldCells = fields.map(function (x, i) {
            let el = document.createElement('th');
            el.textContent = x == null ? '' : String(x);
            if (i === 0) el.style.width = '120px';
            return el;
        });
        modal.find('.modal-body thead').html(fieldCells);

        let tableBody = modal.find('.modal-body tbody');
        let rowEls = rows.map(function (row) {
            let rowEl = document.createElement('tr');
            let cells = row.map(function (x, i) {
                let el = document.createElement('td');
                el.textContent = x == null ? '' : String(x);
                if (i !== 0) {
                    el.style = 'modal-history tbody td';
                }
                return el;
            });
            $(rowEl).append(cells);
            return rowEl;
        });
        tableBody.html(rowEls);
    });
});

//Скролва до горния край на страниата преди принт. Изчакване, за да сме сигурни, че е сролнало до горе преди да принтира. 
function scrollToTopAndPrint() {
    window.scrollTo(0, 0);
    setTimeout(function () {
        window.print();
    }, 100);
}
//При натискане на ctrl + p се вика scrollToTopAndPrint
document.addEventListener("DOMContentLoaded", function () {
    // Override the default print shortcut
    document.addEventListener('keydown', function (e) {
        if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
            e.preventDefault();
            scrollToTopAndPrint();
        }
    });
});